import { type IResponseMergeField } from 'entities/Integrations'

export const mockMergeField: IResponseMergeField = {
  key: '',
  value: '',
  updatedAt: '',
  createdAt: '',
  name: '',
  label: '',
  type: '',
  fieldType: '',
  description: '',
  groupName: '',
  options: [],
  displayOrder: 0,
  calculated: false,
  externalOptions: false,
  hasUniqueValue: false,
  hidden: false,
  hubspotDefined: false,
  modificationMetadata: {
    archivable: false,
    readOnlyDefinition: false,
    readOnlyValue: false,
  },
  formField: false,
  dataSensitivity: '',
  photo_url: '',
  template: '',
  integrationKey: 'hubspot',
  integrationId: 2,
}
